var map = {
	"./de-CH/ui-lib": [
		4464,
		4464
	],
	"./de-DE/ui-lib": [
		10363,
		363
	],
	"./en-CH/ui-lib": [
		81275,
		1275
	],
	"./en-GB/ui-lib": [
		86196,
		6196
	],
	"./en-US/ui-lib": [
		31609,
		1609
	],
	"./es-ES/ui-lib": [
		40360,
		360
	],
	"./fr-CH/ui-lib": [
		57996,
		7996
	],
	"./fr-FR/ui-lib": [
		77585,
		7585
	],
	"./it-CH/ui-lib": [
		79245,
		9245
	],
	"./it-IT/ui-lib": [
		21725,
		1725
	],
	"./ja-JP/ui-lib": [
		70934,
		934
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 77595;
module.exports = webpackAsyncContext;